var _path, _path2, _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.89,99.46l-2.21-3.64C401.06,65.13,367.4,46.64,331.9,48.88a93,93,0,0,0-13.58,1.87c-32.27,6.91-60.35,31.31-72,62.56-6.85,18.38-8.76,39.55-21.75,54.14-16.91,19-45.61,19.58-70.84,18.8s-54-.12-70.78,18.94c-10.54,11.94-13.89,28.92-13,44.91,2.25,42.33,31.75,80.18,69.26,99s81.68,20.5,122.74,12.23c57.51-11.6,112.2-43.44,145.08-92.61S448.2,152.53,421.89,99.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.75,
    cy: 212.94,
    r: 16.64,
    transform: "translate(-139.22 89.77) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.32,
    cy: 58.05,
    r: 16.64,
    transform: "translate(281.81 471.57) rotate(-76.81)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.85,74.66a36.14,36.14,0,0,0-19.73,47.08l22.41,54.7,10-4.11-22.4-54.71a25.23,25.23,0,0,1,46.7-19.12l10.05-4.12A36.12,36.12,0,0,0,75.85,74.66Z",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.85,74.66a36.14,36.14,0,0,0-19.73,47.08l22.41,54.7,10-4.11-22.4-54.71a25.23,25.23,0,0,1,46.7-19.12l10.05-4.12A36.12,36.12,0,0,0,75.85,74.66Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 65.15,
    y: 136.1,
    width: 97.29,
    height: 62.42,
    rx: 5.81,
    transform: "translate(-54.91 55.6) rotate(-22.27)",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.23,156.7a8.13,8.13,0,1,0-6.62,11.13l4.6,11.25,4.11-1.68-4.61-11.25A8.1,8.1,0,0,0,118.23,156.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.16,207.18c-.21.09-4.32-9.48-9.18-21.36s-8.65-21.58-8.44-21.67,4.32,9.48,9.18,21.37S83.36,207.1,83.16,207.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.76,171.85a2.77,2.77,0,0,1-1.08-.14,10.14,10.14,0,0,1-2.75-1.19,11.38,11.38,0,0,1-2.73-17.36,9.51,9.51,0,0,1,2.25-2c.6-.37,1-.51,1-.47a25.93,25.93,0,0,0-2.8,2.79,11.28,11.28,0,0,0,2.6,16.53A26.35,26.35,0,0,0,108.76,171.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.94,181.71l.49-1.42.93,1.18a6.21,6.21,0,0,0,2.88,2l1.42.49-1.18.93a6.34,6.34,0,0,0-2,2.88L47,189.22,46,188.05a6.31,6.31,0,0,0-2.89-2l-1.41-.49,1.17-.93A6.34,6.34,0,0,0,44.94,181.71Z",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,125.92l.28-.82.54.68A3.69,3.69,0,0,0,94.9,127l.82.28-.68.55a3.63,3.63,0,0,0-1.19,1.67l-.28.82L93,129.6a3.54,3.54,0,0,0-1.67-1.18l-.83-.29.69-.54A3.68,3.68,0,0,0,92.4,125.92Z",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.33,132.87l.82-2.39,1.57,2a10.48,10.48,0,0,0,4.84,3.42l2.38.82-2,1.57a10.57,10.57,0,0,0-3.43,4.84l-.82,2.38-1.56-2a10.5,10.5,0,0,0-4.84-3.43l-2.38-.82,2-1.56A10.58,10.58,0,0,0,35.33,132.87Z",
    style: {
      fill: "#6533FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.06,479.9l-147.61-.09a32.16,32.16,0,0,1-32.14-32.16l.07-370.07a32.16,32.16,0,0,1,32.18-32.15l147.61.08a32.16,32.16,0,0,1,32.14,32.16l-.07,370.08A32.16,32.16,0,0,1,311.06,479.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,58.6H282.4a7.1,7.1,0,0,0-6.95,7.26V71a7.11,7.11,0,0,1-6.95,7.26l-55.78,0a7.12,7.12,0,0,1-7-7.27V65.81a7.11,7.11,0,0,0-6.95-7.27H163.7A22.53,22.53,0,0,0,141.16,81l-.07,361.22a22.52,22.52,0,0,0,22.51,22.52l147.32.09a22.51,22.51,0,0,0,22.53-22.52l.07-361.21A22.52,22.52,0,0,0,311,58.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.63,437.25a2.83,2.83,0,1,1-2.86-2.8A2.84,2.84,0,0,1,223.63,437.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.47,437.12a2.83,2.83,0,1,1-2.85-2.8A2.83,2.83,0,0,1,239.47,437.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.32,437a2.83,2.83,0,1,1-2.85-2.8A2.83,2.83,0,0,1,255.32,437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.88,95.08c0,.08-3.73.18-8.32.22s-8.31,0-8.31-.09S299,95,303.56,95,311.87,95,311.88,95.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.91,99.33c0,.09-3.72.19-8.31.23s-8.32,0-8.32-.09,3.72-.19,8.32-.23S311.91,99.24,311.91,99.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,103.58c0,.09-3.73.19-8.32.23s-8.31,0-8.31-.09,3.72-.18,8.31-.22S311.94,103.5,312,103.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.65,108.44l.34,0,1,0,3.56-.08-.09.09c0-.78,0-1.64,0-2.57a14.72,14.72,0,0,1,0-1.48,1.33,1.33,0,0,1,1.17-1.08c.57,0,1.08,0,1.7,0a1.35,1.35,0,0,1,1.15,1.35c0,1.2,0,2.46,0,3.76l-.15-.15,4.48,0-.15.15c0-1.8,0-3.67,0-5.58,0-.47,0-1,0-1.42a1.17,1.17,0,0,0-.18-.58,4.13,4.13,0,0,0-.46-.49c-.66-.65-1.31-1.3-2-1.93l-1.89-1.86c-.3-.31-.61-.61-.91-.91s-.56-.62-.94-.69a1.21,1.21,0,0,0-1,.2c-.27.23-.56.55-.83.82l-1.61,1.62c-1,1-2.06,2-2.83,2.92a3.21,3.21,0,0,0-.22,1.68c0,.56,0,1.08,0,1.58,0,1,0,1.82,0,2.54s0,1.2,0,1.63,0,.58,0,.58,0-.18,0-.54,0-1,0-1.6,0-1.58-.05-2.56c0-.51,0-1,0-1.61,0-.29,0-.58,0-.88a1.83,1.83,0,0,1,.25-.93c.83-1,1.82-1.91,2.84-3l1.59-1.63c.29-.28.53-.57.86-.86a1.51,1.51,0,0,1,1.29-.25,2.38,2.38,0,0,1,1.06.76l.92.9,1.9,1.86,2,1.93a3.76,3.76,0,0,1,.5.54,1.5,1.5,0,0,1,.23.74c0,.48,0,1,0,1.43,0,1.91,0,3.78,0,5.58v.15h-.16l-4.48,0h-.14v-.15c0-1.3,0-2.55,0-3.75a1.11,1.11,0,0,0-.92-1.11c-.52,0-1.13,0-1.63,0a1.11,1.11,0,0,0-1,.88c0,.46,0,1,0,1.43,0,.93,0,1.79,0,2.58v.09h-.09l-3.61,0H161A1.64,1.64,0,0,1,160.65,108.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 193,
    y: 205,
    style: {
      fill: "#263238",
      fontFamily: "Montserrat, sans-serif",
      fontWeight: 700,
      fontSize: 25
    }
  }, "C\xF3digo"), /*#__PURE__*/React.createElement("path", {
    d: "M321,217c0,.14-37,.26-82.69.26s-82.71-.12-82.71-.26,37-.26,82.71-.26S321,216.83,321,217Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.15,369.23c0,.15-37,.26-82.7.26s-82.7-.11-82.7-.26,37-.26,82.7-.26S317.15,369.09,317.15,369.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.74,380.67c0,.14-20.57.26-45.94.26s-45.94-.12-45.94-.26,20.56-.26,45.94-.26S279.74,380.52,279.74,380.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5,261.3l3.13,1.69-1.41,2.36-3.16-1.87.06,3.48h-2.7l0-3.51-3.17,1.9L161.9,263,165,261.3l-3.14-1.73,1.38-2.35,3.17,1.89,0-3.5h2.7l-.06,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.42,261.3l3.13,1.69-1.41,2.36L205,263.48,205,267h-2.71l0-3.51-3.16,1.9L197.82,263,201,261.3l-3.13-1.73,1.38-2.35,3.16,1.89,0-3.5H205l-.06,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.38,261.3l3.13,1.69-1.41,2.36-3.16-1.87L240,267h-2.7l0-3.51-3.17,1.9L232.78,263l3.14-1.69-3.14-1.73,1.38-2.35,3.17,1.89,0-3.5H240l-.06,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.25,261.3l3.13,1.69L277,265.35l-3.16-1.87.06,3.48h-2.7l0-3.51-3.16,1.9L266.65,263l3.14-1.69-3.14-1.73,1.38-2.35,3.16,1.89,0-3.5h2.7l-.06,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.85,261.3,312,263l-1.41,2.36-3.16-1.87.05,3.48h-2.7l0-3.51-3.16,1.9L300.26,263l3.13-1.69-3.13-1.73,1.38-2.35,3.16,1.89,0-3.5h2.7l-.05,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.07,283.08H160.92a7.08,7.08,0,0,1-7.07-7.07v-26.9a7.07,7.07,0,0,1,7.07-7.06h15.15a7.07,7.07,0,0,1,7.07,7.06V276A7.08,7.08,0,0,1,176.07,283.08Zm-15.15-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.58,6.58,0,0,0,6.57,6.57h15.15a6.57,6.57,0,0,0,6.57-6.57v-26.9a6.57,6.57,0,0,0-6.57-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26,283.08H196.11A7.08,7.08,0,0,1,189,276v-26.9a7.07,7.07,0,0,1,7.07-7.06h15.15a7.07,7.07,0,0,1,7.07,7.06V276A7.08,7.08,0,0,1,211.26,283.08Zm-15.15-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.58,6.58,0,0,0,6.57,6.57h15.15a6.57,6.57,0,0,0,6.57-6.57v-26.9a6.57,6.57,0,0,0-6.57-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.49,283.08H230.33a7.08,7.08,0,0,1-7.07-7.07v-26.9a7.07,7.07,0,0,1,7.07-7.06h15.16a7.07,7.07,0,0,1,7.06,7.06V276A7.07,7.07,0,0,1,245.49,283.08Zm-15.16-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.58,6.58,0,0,0,6.57,6.57h15.16a6.57,6.57,0,0,0,6.56-6.57v-26.9a6.56,6.56,0,0,0-6.56-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1,283.08H264.94a7.08,7.08,0,0,1-7.07-7.07v-26.9a7.07,7.07,0,0,1,7.07-7.06H280.1a7.07,7.07,0,0,1,7.06,7.06V276A7.07,7.07,0,0,1,280.1,283.08Zm-15.16-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.58,6.58,0,0,0,6.57,6.57H280.1a6.57,6.57,0,0,0,6.56-6.57v-26.9a6.56,6.56,0,0,0-6.56-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.7,283.08H298.55a7.08,7.08,0,0,1-7.07-7.07v-26.9a7.07,7.07,0,0,1,7.07-7.06H313.7a7.07,7.07,0,0,1,7.07,7.06V276A7.08,7.08,0,0,1,313.7,283.08Zm-15.15-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.57,6.57,0,0,0,6.57,6.57H313.7a6.58,6.58,0,0,0,6.57-6.57v-26.9a6.57,6.57,0,0,0-6.57-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.09,
    y: 315.56,
    width: 169.79,
    height: 29.74,
    rx: 11.29,
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 208,
    y: 334,
    style: {
      fill: "#fff",
      fontFamily: "system-ui",
      fontWeight: 500
    }
  }, "Entregar"), _image || (_image = /*#__PURE__*/React.createElement("image", {
    href: "http://127.0.0.1:5500/src/assets/logo-icon.png",
    x: 205,
    y: 112,
    height: "62px",
    width: "62px"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461,480.17c0,.15-97.17.26-217,.26s-217-.11-217-.26,97.15-.26,217-.26S461,480,461,480.17Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.66,342.46c9.51-14.56,9.15-35.84-2.22-49-3.53-4.09-8.46-7.64-13.84-7.18S57.66,291.47,56,296.74s-1.09,11-.11,16.41c1.38,7.62,3.69,15.41,9,21.07s12,11.95,18.82,8.24",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.41,412a21.73,21.73,0,0,0-6.06-24.7c-2.19-1.79-5-3.17-7.78-2.44s-4.65,3.57-5,6.44A18,18,0,0,0,62,399.81c1.4,3.79,3.3,7.6,6.53,10s7.76,4.72,10.92,2.19",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.37,407.05c-2.62-12.91,4.18-27.15,15.86-33.23,3.63-1.88,8.09-3,11.75-1.17s5.54,6.44,5.24,10.62-2.3,8-4.52,11.57c-3.1,5-6.91,9.81-12.21,12.31s-12.39,4.41-16.12-.1",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.72,372.15c-4.56-14.71,3.17-32.54,16-41,4-2.62,9.06-4.44,13.53-2.74s7.2,6.84,7.34,11.73-1.74,9.6-3.9,14c-3,6.15-6.89,12.22-12.76,15.75s-15.38,7-20.25,2.24",
    style: {
      fill: "#6533FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.57,444a3,3,0,0,0,.14-.71c.08-.53.19-1.21.31-2.05.06-.45.13-.95.21-1.48s.21-1.13.33-1.75c.24-1.26.49-2.69.9-4.24.19-.79.39-1.61.59-2.46s.51-1.71.77-2.62c.49-1.82,1.22-3.71,1.9-5.72a99.62,99.62,0,0,1,13-24.28c1.3-1.68,2.47-3.33,3.72-4.74.61-.73,1.2-1.42,1.76-2.1L117,390c1.07-1.2,2.12-2.2,3-3.09l1.27-1.25,1.12-1,1.54-1.39a3.73,3.73,0,0,0,.51-.51,3,3,0,0,0-.59.42l-1.62,1.3-1.16.95-1.31,1.22c-.94.87-2,1.85-3.12,3l-1.76,1.83c-.57.67-1.17,1.37-1.79,2.08-1.28,1.41-2.47,3.06-3.8,4.74a107.52,107.52,0,0,0-7.44,11.73,104.55,104.55,0,0,0-5.66,12.69c-.67,2-1.38,3.93-1.85,5.78-.26.91-.5,1.79-.74,2.64s-.38,1.69-.56,2.48c-.38,1.57-.6,3-.81,4.28-.1.63-.2,1.22-.29,1.76s-.1,1-.15,1.5c-.08.84-.14,1.53-.19,2.07A2.32,2.32,0,0,0,91.57,444Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9,446.67a1.17,1.17,0,0,0,0-.3c0-.23,0-.51-.06-.85-.07-.8-.18-1.89-.3-3.27-.07-.71-.15-1.5-.24-2.35s-.08-1.81-.14-2.82c-.07-2-.27-4.32-.19-6.86,0-1.28,0-2.61,0-4s.14-2.83.21-4.32c.1-3,.51-6.16.87-9.51a136.34,136.34,0,0,1,12.38-41.77c1.53-3,2.91-5.88,4.46-8.44.76-1.29,1.43-2.57,2.18-3.74l2.16-3.36c1.33-2.18,2.74-4,3.9-5.65.6-.82,1.13-1.59,1.66-2.28l1.48-1.85,2-2.58.52-.68c.11-.15.17-.23.16-.24s-.08.06-.21.2l-.56.64-2.13,2.51L118.57,347c-.54.68-1.09,1.44-1.7,2.25-1.19,1.64-2.63,3.45-4,5.61l-2.2,3.35c-.76,1.17-1.45,2.45-2.22,3.74-1.57,2.56-3,5.45-4.52,8.45A132.79,132.79,0,0,0,91.5,412.32c-.35,3.36-.74,6.55-.82,9.55-.05,1.5-.17,2.95-.18,4.34s0,2.73,0,4c0,2.55.18,4.86.29,6.88.07,1,.11,2,.19,2.82s.2,1.64.29,2.36c.17,1.37.31,2.46.41,3.26.05.34.1.61.13.84A1.19,1.19,0,0,0,91.9,446.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.12,303.86a1.39,1.39,0,0,0,.13.27c.11.2.24.46.41.76l1.62,2.91c.35.63.77,1.32,1.18,2.1l1.27,2.56,1.47,2.94c.49,1.05,1,2.18,1.49,3.36s1.08,2.42,1.61,3.72,1,2.69,1.58,4.1l.83,2.16c.25.75.51,1.5.77,2.27.51,1.53,1,3.11,1.59,4.72,2,6.53,3.93,13.79,5.54,21.51s2.66,15.16,3.47,21.94,1.21,12.93,1.35,18.1c.13,2.58.16,4.91.16,7s0,3.82,0,5.26,0,2.52,0,3.33v.87c0,.19,0,.29,0,.29a1.22,1.22,0,0,0,0-.29c0-.23,0-.51.06-.86,0-.82.09-1.93.16-3.33s.11-3.22.11-5.27,0-4.4-.07-7c-.09-5.18-.55-11.33-1.22-18.14s-1.86-14.26-3.43-22-3.55-15-5.6-21.55L80,330.83c-.26-.77-.52-1.53-.78-2.27l-.85-2.16-1.62-4.1c-.54-1.31-1.12-2.53-1.65-3.72s-1-2.31-1.54-3.35-1-2-1.51-2.93-.92-1.76-1.32-2.55-.86-1.45-1.23-2.07l-1.73-2.85c-.18-.3-.34-.54-.46-.73S67.13,303.85,67.12,303.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.36,393.18a12.23,12.23,0,0,0,1,1.78c.7,1.11,1.65,2.76,2.77,4.82s2.36,4.56,3.61,7.39,2.43,6,3.5,9.45,1.83,6.73,2.44,9.77,1,5.81,1.19,8.15.38,4.22.43,5.53a12,12,0,0,0,.17,2,14.28,14.28,0,0,0,.07-2c0-1.32,0-3.23-.23-5.57a82.71,82.71,0,0,0-1.07-8.21,93.7,93.7,0,0,0-2.41-9.86,90.49,90.49,0,0,0-3.57-9.49c-1.28-2.84-2.56-5.34-3.74-7.38s-2.19-3.66-3-4.73A15.37,15.37,0,0,0,70.36,393.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.26 437.47 68.45 437.47 73.51 480.17 105.05 480.17 110.26 437.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.73 475.56 105.18 480.17 73.51 480.17 69.86 475.71 108.73 475.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.08,450c0,.17,8.68.31,19.38.31s19.37-.14,19.37-.31-8.67-.31-19.37-.31S70.08,449.86,70.08,450Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.08,452.87c0,.17,8.68.31,19.38.31s19.37-.14,19.37-.31-8.67-.31-19.37-.31S70.08,452.7,70.08,452.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6,455.62c0,.18,8.37.32,18.7.32s18.7-.14,18.7-.32-8.37-.31-18.7-.31S70.6,455.45,70.6,455.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.87,345.44a1.82,1.82,0,0,0,0,.41c0,.31.05.7.09,1.16.11,1.07.25,2.51.43,4.25.38,3.59.94,8.55,1.58,14,0,.21,0,.42.07.61l0,.19h.19c5.37.08,10.2.13,13.69.15h4.13l1.12,0c.26,0,.39,0,.39,0a1.52,1.52,0,0,0-.38-.05l-1.12-.05-4.13-.13c-3.49-.1-8.32-.2-13.7-.28l.21.18c0-.19,0-.4-.07-.61-.64-5.47-1.24-10.42-1.7-14-.23-1.74-.42-3.17-.57-4.24-.06-.46-.12-.84-.17-1.15A1.17,1.17,0,0,0,103.87,345.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,332.67a1.3,1.3,0,0,0,0,.42c0,.32,0,.72,0,1.2,0,1.1,0,2.59,0,4.41.06,3.72.16,8.86.3,14.53,0,.23,0,.46,0,.67v.22h.22a129,129,0,0,1,14.06-.32c1.79,0,3.24.13,4.24.18l1.15,0h.4s-.13,0-.39-.08l-1.15-.13c-1-.1-2.44-.22-4.24-.32a112.41,112.41,0,0,0-14.1.19l.23.21c0-.21,0-.44,0-.67-.14-5.68-.29-10.81-.42-14.53-.07-1.81-.13-3.3-.17-4.4,0-.48,0-.88-.07-1.2A2.1,2.1,0,0,0,113.38,332.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5,328.32a8.88,8.88,0,0,0-.26,1.23c-.16.86-.36,2-.62,3.36-.54,2.84-1.39,6.75-2.58,11l-.13.45.43-.2.5-.25A36.32,36.32,0,0,1,133,340.68c1.49-.18,2.7-.25,3.53-.28a6.67,6.67,0,0,0,1.3-.07,1,1,0,0,0-.33,0c-.22,0-.55-.05-1-.05a29.23,29.23,0,0,0-3.56.15,33.88,33.88,0,0,0-11.29,3.17l-.51.25.3.24A108.31,108.31,0,0,0,123.91,333c.24-1.43.4-2.59.49-3.39A6.1,6.1,0,0,0,124.5,328.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.46,406.17c0,.06,1.22-.06,3.17-.14a53.61,53.61,0,0,1,7.6.25c.6.06,1.19.14,1.75.22l.2,0,0-.19c.46-2.53.83-4.76,1.09-6.36a18.45,18.45,0,0,0,.33-2.58,17,17,0,0,0-.6,2.53c-.33,1.59-.76,3.81-1.23,6.33l.24-.17c-.57-.08-1.16-.16-1.77-.22a42.87,42.87,0,0,0-7.66-.13c-1,.08-1.77.18-2.31.26A3.53,3.53,0,0,0,65.46,406.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.52,398.32c0,.07,1.17-.2,3.06-.44a33.17,33.17,0,0,1,7.42-.07l1.31.16.22,0,0-.21c.26-2.6.47-4.91.61-6.56a17.08,17.08,0,0,0,.13-2.67,19.64,19.64,0,0,0-.41,2.64c-.21,1.65-.47,3.95-.75,6.54l.24-.18L72,397.39a28.8,28.8,0,0,0-7.5.2,21.53,21.53,0,0,0-2.23.47A3.41,3.41,0,0,0,61.52,398.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.68,324a2.45,2.45,0,0,0,.42.22l1.22.54,4.52,1.92,15,6.21.81.33.19.08.08-.19c2.47-5.58,4.69-10.6,6.33-14.29l1.86-4.32.49-1.18a2.5,2.5,0,0,0,.14-.43,2.23,2.23,0,0,0-.22.39c-.15.31-.33.69-.56,1.15l-2,4.27-6.45,14.24.28-.11-.81-.33L65,326.4l-4.57-1.8-1.25-.47A1.82,1.82,0,0,0,58.68,324Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,305.93a2.2,2.2,0,0,0,.37.27l1.1.71,4.08,2.54,13.61,8.31.22.13.09-.24.25-.66,5.71-15.4c.69-1.93,1.26-3.52,1.68-4.68l.44-1.28a1.65,1.65,0,0,0,.12-.46,3.17,3.17,0,0,0-.2.43L82,296.85c-.44,1.15-1.06,2.72-1.81,4.64-1.5,4-3.55,9.38-5.82,15.36-.08.22-.17.45-.24.65l.3-.11L60.72,309.2l-4.15-2.43-1.14-.64A2.13,2.13,0,0,0,55,305.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.22,296.29a5.16,5.16,0,0,0,.9.53c.59.33,1.44.81,2.47,1.45a43.73,43.73,0,0,1,7.57,5.93l.53.51-.18-.72c-.18-.74-.35-1.53-.48-2.34a27.26,27.26,0,0,1,.59-11.14,33.4,33.4,0,0,1,1.07-3.25,7.3,7.3,0,0,0,.45-1.17,7.72,7.72,0,0,0-.6,1.11,26.81,26.81,0,0,0-1.21,3.22,26.19,26.19,0,0,0-.72,11.29c.13.83.31,1.63.5,2.39l.35-.2A40.25,40.25,0,0,0,59.73,298c-1.06-.61-1.93-1.06-2.54-1.34A5.84,5.84,0,0,0,56.22,296.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.93,390a5.44,5.44,0,0,0,.19,1.08c.14.69.35,1.69.58,2.93a72.76,72.76,0,0,1,1.13,9.91v.19H106l.94,0c4.15.25,7.9.46,10.62.58l3.22.13a6.32,6.32,0,0,0,1.18,0,6.26,6.26,0,0,0-1.17-.15l-3.21-.27c-2.72-.2-6.47-.45-10.61-.7l-.94-.05.2.2A62.29,62.29,0,0,0,105,394c-.27-1.25-.52-2.24-.72-2.92A5.79,5.79,0,0,0,103.93,390Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.14,378.26a5.56,5.56,0,0,0,.07,1.09c.09.77.2,1.77.34,3,.3,2.51.75,6,1.28,9.92l0,.17H114l1.34.09c4.25.29,8.08.73,10.85,1.09l3.28.44a7.05,7.05,0,0,0,1.2.12,5.93,5.93,0,0,0-1.18-.28c-.76-.16-1.88-.36-3.26-.58-2.76-.43-6.6-.92-10.86-1.21l-1.35-.09.2.18c-.54-3.91-1-7.4-1.42-9.9-.19-1.19-.34-2.18-.46-2.95A5,5,0,0,0,112.14,378.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.81,373.18c-.06,0,.2,1.15.49,3a52.55,52.55,0,0,1,.68,7.4v.23l.24,0,.7-.09a65.1,65.1,0,0,1,7.89-.47l2.41,0a3.8,3.8,0,0,0,.88,0,3.4,3.4,0,0,0-.87-.14c-.57-.06-1.39-.13-2.41-.16a50.46,50.46,0,0,0-7.95.34l-.71.09.24.21a43.41,43.41,0,0,0-.81-7.44c-.19-.93-.37-1.68-.51-2.19A2.83,2.83,0,0,0,121.81,373.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.73,385a37.57,37.57,0,0,0,1.87,4.24,37.86,37.86,0,0,0,2,4.18A19.27,19.27,0,0,0,69,389,19.53,19.53,0,0,0,66.73,385Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.48,390.53a43.62,43.62,0,0,1,4.75,1,41.59,41.59,0,0,1,4.46,1.9,10.67,10.67,0,0,0-4.34-2.3A10.8,10.8,0,0,0,61.48,390.53Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.41da913e38903431d3eb9ba3d5d5c2ec.svg";
export { ForwardRef as ReactComponent };